// extracted by mini-css-extract-plugin
module.exports = {"dialog-content":"dialog_dialog-content__61VT8","dialog-close":"dialog_dialog-close__VtBcK","dialog-title":"dialog_dialog-title__dMw31"};